import { obterDesconto } from '../financeiro';
import { obterValoresByMovimentoItens } from '../movimento';
import { toNumberBR } from '../masks';

export function aplicarDescontoFinanceiroCabecalho({ name, value, dados }) {
    const totalAtual = Number(dados?.totalValor) || 0;

    if (totalAtual <= 0) {
        return dados;
    }

    const movimentoItems = dados?.movimentoItems || [];
    const parcela = Number(dados?.parcela || 1);

    const valorDigitado = name === 'descontoFinanceiro' ? toNumberBR(value) : toNumberBR(dados?.descontoFinanceiro);

    const percentualDigitado =
        name === 'descontoFinanceiroPercentual' ? Number(value || 0) : Number(dados?.descontoFinanceiroPercentual || 0);

    const desconto =
        name === 'descontoFinanceiro'
            ? obterDesconto({
                  valorTotal: totalAtual,
                  desconto: valorDigitado,
              })
            : obterDesconto({
                  valorTotal: totalAtual,
                  descontoPercentual: percentualDigitado,
              });

    const totaisItens = obterValoresByMovimentoItens(movimentoItems, {
        parcela,
        considerarFator: false,
        retornaItensCalculados: false,
    });

    const valores = totaisItens?.valores || {};

    const bruto = Number(valores?.bruto || 0);
    const descontoItens = Number(valores?.descontoItens || 0);
    const descontoFinanceiro = Number(desconto?.descontoValor || 0);

    const totalPedido = Number(Math.max(0, bruto - descontoItens - descontoFinanceiro).toFixed(2));

    return {
        ...dados,
        descontoFinanceiro: descontoFinanceiro?.toFixed(2),
        descontoFinanceiroPercentual: desconto?.descontoPercentual ?? 0,
        totalValor: totalPedido,
        valorParcela: parcela > 0 ? Number((totalPedido / parcela).toFixed(2)) : totalPedido,
    };
}
